<template>
  <div class="container-fluid">
    <div class="d-flex flex-column-reverse flex-md-row mx-0 mx-md-5 mt-20 mt-lg-15 mt-xl-10">
      <div class="col-12 col-md-6 mt-2 mt-sm-5 mt-md-0">

        <h1 class="display-1 text-center text-md-left mt-0 mt-xl-5">Protect your invoices</h1>
        <h3 class="text-center text-md-left">Your invoices protected in less than 60 seconds. So you get paid, even if your customers don't pay you.</h3>

        <div class="my-5 text-center text-md-left ">
          <button class="button buttonLarge bgHokodo" @click="goToPage">Show me how!</button>
          <button class="button buttonLarge bgWhite" @click="goToSignIn">Already a customer? Sign in</button>
        </div>
      </div>
      <div class="col-12 col-md-6 text-center mt-5 mt-sm-1">
        <img class="img-fluid mw-75 mw-md-100" src="@/assets/img/protect-umbrella.svg" >
      </div>
    </div>
  </div>
</template>

<style lang="scss">
// Landing page template
#landing{
    height:100%;
    padding-top: 6rem;

    #hero {
      background-repeat:no-repeat;
      background-size:auto;
      height:100%;
      display: flex;
      -webkit-box-flex: 0;
      flex-wrap: wrap;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      align-items: center;
      justify-content: center;
    }

    .hero-region {
      max-width: 100%;
      flex-basis:50%;
      flex: 0 0 auto;
      -webkit-box-flex: 0;
      padding: 20px;
    }

    .hero-image {
      max-width: 100%;
    }

    section {
      display: flex;
      align-items: center;
      padding:15px;
    }

    .landing-speech {
      justify-content: center;
      margin:auto;
      max-width: 960px;
      min-height: 30%;
      flex-wrap: wrap;

      .section-img {
        flex: none;
      }
      .section-body {
        text-align: center;
        padding: 15px;
      }
    }
  }
</style>

<script>
export default {
  name: 'landing',
  mounted () {
    // Segment track - Landing page viewed
    window.analytics.page('Home', 'Landing')
    // Segment track - Identify the Env in intercom
    window.analytics.identify({
      baseURL: process.env.VUE_APP_ROOT_API,
      standaloneURL: process.env.VUE_APP_STANDALONE_API
    })
  },
  methods: {
    // Segment-Track Landing page CTA
    goToPage () {
      this.$router.push({ name: 'protect' })
      window.analytics.track('Landing - Hero CTA Clicked')
      // Segment-Track Buying of first policy after CTA clicked
      window.analytics.track('Buy First Policy - Started')
    },
    goToSignIn () {
      window.location = process.env.VUE_APP_CUSTOMER_PORTAL
      window.analytics.track('Buy First Policy - Sign In')
    }
  }
}
</script>
